import "./style.scss";
import {Box, Button, Link, Typography} from "@mui/material";
import {openPopupWidget} from "react-calendly";
import FormHelper from "../helpers/FormHelper";
import CalcHelper from "../helpers/CalcHelper";
import calculateLoan from "../helpers/CalcHelper";

function Actions({actions, quote, amount, period, rate, purposes, purpose, requestQuoteHandler}) {
    const _purposeData = FormHelper.parsePurposeData(purposes[purpose]);
    const mrepay = calculateLoan(amount, period, 1, rate);
    const wrepay = calculateLoan(amount, period, 3, rate)
    const frepay = calculateLoan(amount, period, 2, rate)

    const handleQuote = () => {
        requestQuoteHandler();
    }
    return <>
        <Box className="calc-actions-wrapper">
            {quote ? (<>
                <Typography component="p" className="calc-actions-text">Start your Application Today</Typography>
                <Box className='calc-actions-quote'>
                    {actions.connection ? (
                    <Button className="calc-button"
                            component="a"
                          href={actions.connection + "?amount=" + amount + "&term=" + period + "&rate="
                          + rate + "&type=" + _purposeData.lp_title + "&mrepay=" + mrepay.mrepay
                          + "&wrepay=" + wrepay.mrepay + "&frepay=" + frepay.mrepay + "&secured=" + (_purposeData.cl_secured | 0)+ "&mortgage=" + (_purposeData.cl_mortgage| 0)}
                    >Start Application</Button>
                    ):('')}
                </Box>
            </>) : (<>
                <Box className='calc-actions'>
                    <Button component="a"
                            className="calc-button"
                            onClick={handleQuote}>Start Application</Button>
                </Box>
            </>)}
        </Box>
    </>
}

export default Actions;
